import { useWindowSize } from 'CustomHooks';
import React, { useEffect, useState, useRef } from 'react';
import { base64ToImage } from 'utils/Global';

interface Props {
  image: string;
}

const Histogram = (props: Props) => {
  const { image = '' } = props;
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [canvasWidth, setCanvasWidth] = useState<number>();
  const windowSize = useWindowSize();

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) {
      return;
    }

    const ctx = canvas.getContext('2d');
    if (!ctx) {
      return;
    }

    const processImage = (inImg) => {
      const pixels = inImg.data;
      const histogram = new Array(256).fill(0);

      for (let i = 0; i < pixels.length; i += 4) {
        const pixelValue = pixels[i];
        histogram[pixelValue]++;
      }

      let maxBrightness = 0;
      for (let i = 1; i < 256; i++) {
        if (maxBrightness < histogram[i]) {
          maxBrightness = histogram[i];
        }
      }

      canvas.width = canvasWidth;
      canvas.height = 150;

      const guideHeight = 8;
      const startY = canvas.height - guideHeight;
      const dx = canvas.width / 256;
      const dy = startY / maxBrightness;
      ctx.lineWidth = dx;
      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      for (let i = 0; i < 256; i++) {
        const x = i * dx;
        ctx.strokeStyle = '#000000';
        ctx.beginPath();
        ctx.moveTo(x, startY);
        ctx.lineTo(x, startY - histogram[i] * dy);
        ctx.closePath();
        ctx.stroke();
      }
    };

    const generateHistogram = async (base64) => {
      const img = await base64ToImage(base64);
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const imageData = ctx.getImageData(0, 0, img.width, img.height);
      processImage(imageData);
    };

    if (image) {
      generateHistogram(image);
    }
  }, [image, canvasWidth, windowSize.width]);

  useEffect(() => {
    const div = document.getElementById('canvasWrapper');
    const parentDivWidth = div?.getBoundingClientRect().width || 512;
    setCanvasWidth(parentDivWidth);
  }, [windowSize.width]);

  return (
    <div id="histogram-canvaswrapper" className="w-full">
      <canvas
        ref={canvasRef}
        id="canvasHistogram"
        width={canvasWidth}
        height="150"
      ></canvas>
    </div>
  );
};

export default Histogram;
